// ListViewIgnore: Fields not to include as columns anywhere in the datagrid
export const ListViewIgnore = [
    "v0", "listId", "0", "hash1", "itemcode", "externalID", "board_id", "column_id", "history", "levelFilter"
]

// ListViewDefaultDisplayValues: Fields to display for DataGrid by default
export const ListViewDefaultDisplayValues = [
    "Detail", "Panel", "name", "description","opportunityLabels", "createdOn", "due", "mValue", "opportunityType", "status", "assignedTo"
]
